export default {
   props: {
      value: {
         required: true
      },
      items: {},
      label: {}
   },
   data() {
      return {
         localValue: this.value
      }
   },
   watch: {
      localValue(newValue) {
         this.$emit('input', newValue)
      },
      value(newValue) {
         this.localValue = newValue
      }
   }
}
